import { Injectable, inject } from '@angular/core';

import { CrmPromotionReplaceParametersService } from '../../../../lib/crm-promotion/crm-promotion-replace-parameters.service';
import { IRewardToken } from '../../../../lib/tokens-base/token-base.models';

@Injectable({ providedIn: 'root' })
export class RewardTokensFormattersService {
    private replaceParametersService = inject(CrmPromotionReplaceParametersService);

    private currencySymbolReplacebleParam = '_{CurrencySymbol}_';
    private currencyCodeReplacebleParam = '_{Currency}_';

    replaceCurrency(title: string, currencySymbol: string = '', currencyCode: string = ''): string {
        return title
            .replace(new RegExp(this.currencySymbolReplacebleParam, 'g'), currencySymbol)
            .replace(new RegExp(this.currencyCodeReplacebleParam, 'g'), currencyCode);
    }

    getTokenQuickViewReplaceValue(token: IRewardToken, replace: string | undefined): string {
        return replace
            ? this.replaceParametersService.replaceParameters(this.replaceCurrency(replace), token.replaceableParameters!, false, false, true)
            : '';
    }
}
